<template>
  <div class="h-toolbarBg">
    <ejs-toolbar ref="toolBarForMrTaskManagement">
      <e-items>
        <e-item prefixIcon='icon hero-icon hero-icon-add' :tooltipText='$t("MR.addTaskToorBar")' :click="buttonClick" operate='add'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-start-up' :tooltipText='$t("MR.enableTaskToorBar")' :click="buttonClick" operate='enable'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-disable' :tooltipText='$t("MR.disableTaskToorBar")' :click="buttonClick" operate='disable'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-remove' :tooltipText='$t("MR.deleteTaskToorBar")' :click="buttonClick" operate='delete'></e-item>
      </e-items>
    </ejs-toolbar>
  </div>
</template>

<script>
    export default {
      name: "MrTaskManagementToolBar",
      props: [
        'enableStatus'
      ],
      methods: {
        buttonClick(args) {
          this.$parent.$parent.methodList(args.item.operate);
        }
      },
      watch: {
        enableStatus(enableStatus){
          switch (enableStatus) {
            case '0': // 任务关闭
              this.$refs.toolBarForMrTaskManagement.enableItems([0, 1, 3], true);
              this.$refs.toolBarForMrTaskManagement.enableItems([2], false);
              break;
            case '1': // 任务开启
              this.$refs.toolBarForMrTaskManagement.enableItems([0, 2, 3], true);
              this.$refs.toolBarForMrTaskManagement.enableItems([1], false);
              break;
            default:
              this.$refs.toolBarForMrTaskManagement.enableItems([0], true);
              this.$refs.toolBarForMrTaskManagement.enableItems([1, 2, 3], false);
              break;
          }
        }
      },
      mounted() {
        this.$refs.toolBarForMrTaskManagement.enableItems([0], true);
        this.$refs.toolBarForMrTaskManagement.enableItems([1, 2, 3], false);
      }
    }
</script>

<style scoped>

</style>
